import _getIterator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/get-iterator';
import _extends from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/extends';
import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from '~/plugins/axios';

export default {
  name: "PendingCollection",
  data: function data() {
    return {
      tableFields: {
        fullname: {
          key: 'fullname',
          label: 'Full Name'
        },
        nricFin: {
          key: 'nricFin',
          label: 'Nric / Fin'
        },
        companyName: {
          key: 'companyName',
          label: 'Company'
        },
        viewInfo: {
          key: 'viewInfo',
          label: 'View Info'
        },
        actions: {
          key: 'actions',
          label: 'Actions'
        }
      },
      moduleSessionFields: {
        moduleName: {
          key: 'moduleName',
          label: 'Module Name'
        },
        pendingApprovalList: {
          key: 'pendingApprovalList',
          label: 'Pending List'
        }
      },
      viewFilesModal: {
        obj: {},
        title: '',
        content: []
      },
      viewWorkingProfileModal: {
        obj: {},
        title: '',
        content: []
      },
      viewBookedModuleModal: {
        obj: {},
        title: '',
        content: []
        // status:null
      },

      remarkModal: {
        rejectUserInfo: {},
        title: ''
      },
      rejRemarks: ''
    };
  },
  updated: function updated() {
    // console.log(this.rejRemarks);
  },

  filters: {
    // fileQuantity(userId) {
    //   // console.log('\n\n ====== this !!! ======= \n', this, '\n ------------------');
    //   // let num = getFileQuantity(userId);
    //   console.log('\n\n ====== this !!! ======= \n', userId, '\n ------------------');
    //   return userId;
    // }
    statusFilter: function statusFilter(msStatusCode) {
      if (msStatusCode == 100) {
        return 'Pending Upload File';
      } else if (msStatusCode == 101) {
        return 'Pending Approval';
      } else if (msStatusCode == 102) {
        return 'Pending Attend';
      } else if (msStatusCode == 200) {
        return 'Present -> PendingGrade';
      } else if (msStatusCode == 201) {
        return 'Present with Grade:Pass';
      } else if (msStatusCode == 202) {
        return 'Present with Grade:failed';
      } else if (msStatusCode == 203) {
        return 'present with Grade:N.A';
      } else if (msStatusCode >= 300) {
        return 'REMOVED';
      } else {
        return 'NIL';
      }
    }
  },
  computed: {
    fileQuantity: function fileQuantity(userId) {
      console.log('\n\n ====== this !!! ======= \n', this, '\n ------------------');
      // let num = this.getFileQuantity(userId);
      // return userId;
      return 12;
    }
  },
  methods: {
    getFileQuantity: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userId) {
        var managerId, manager;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                managerId = 'userMsManager' + userId;
                _context.next = 3;
                return axios.post('/userMsManager/obtainSingleManager', { managerId: managerId });

              case 3:
                manager = _context.sent.data;
                return _context.abrupt('return', manager.internalTrainingFiles.length || 0);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getFileQuantity(_x) {
        return _ref.apply(this, arguments);
      }

      return getFileQuantity;
    }(),

    // =========== APPROVE USER INFORMATION ============
    approveUser: function approveUser(rowItem, moduleSession, rowIndex, button) {
      console.log('\n\n ====== PendingCollection.vue approve ======= \n rowItem:', rowItem, '\n moduleSession: ', moduleSession, '\n rowIndex: ', rowIndex, '\n button: ', button, '\n ---------------------');
      var approveUserInfo = { rowItem: rowItem, moduleSession: moduleSession, rowIndex: rowIndex, button: button };
      this.$emit('approveUser', approveUserInfo);
    },


    // =========== REJECT USER INFORMATION ============
    onRejectUser: function onRejectUser(rowItem, moduleSession, rowIndex, button) {
      console.log('\n\n ====== PendingCollection.vue approve ======= \n rowItem:', rowItem, '\n moduleSession: ', moduleSession, '\n rowIndex: ', rowIndex, '\n button: ', button, '\n ---------------------');
      var rejectUserInfo = { rowItem: rowItem, moduleSession: moduleSession, rowIndex: rowIndex, button: button };

      this.remarkModal.title = 'Reason Of Rejection for:' + rowItem.fullname + '[' + rowItem.nricFin + ']';
      // + moduleSession.moduleName;

      console.log('\n\n ======= Remarks ======\n', this.rejRemarks, '\n ---------------------');
      this.remarkModal.rejectUserInfo = _extends({}, rejectUserInfo, { rejRemarks: this.rejRemarks });
      this.$root.$emit('bv::show::modal', 'addRejectionRemarks', button);
      this.rejRemarks = '';
    },
    resetRemarkModal: function resetRemarkModal(modal) {
      if (!!this.rejRemarks) {
        console.log(modal);

        console.log('\n\n ======= Remarks ======\n', this.remarkModal.rejectUserInfo.rejRemarks, '\n ---------------------');

        this.$emit('rejectUser', _extends({}, this.remarkModal.rejectUserInfo, { rejRemarks: this.rejRemarks }));
        this.$refs['rejModal' + this.remarkModal.rejectUserInfo.nricFin].hide();
      } else {
        alert('Please State Reason Of Rejection');
      }
    },


    // ======= View User File -> fetch data with in component ========
    viewApplicantFiles: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(item, index, button) {
        var userActorId, managerId, manager;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('\n\n ======pendingList.vue key of viewApplicantFiles items =========\n', item, '\n -----------------------');
                console.log('\n\n ======pendingList.vue key of viewApplicantFiles key ===========\n', index, '\n -----------------------');
                console.log('\n\n =======pendingList.vue key of viewApplicantFiles item.id ===========\n', item.id, '\n -----------------------');

                userActorId = item.id;
                managerId = 'userMsManager' + userActorId;
                _context2.next = 7;
                return axios.post('/userMsManager/obtainSingleManager', { managerId: managerId });

              case 7:
                manager = _context2.sent.data.manager;


                console.log('\n\n ============ pendingList.vue manager of viewApplicantFiles ============\n', manager, '\n -----------------------');
                this.fileList = manager.internalTrainingFiles;
                this.viewFilesModal.obj = item;
                this.viewFilesModal.title = item.fullname + ' - ' + item.nricFin;
                this.viewFilesModal.content = manager.internalTrainingFiles;

                this.$root.$emit('bv::show::modal', 'viewApplicantFilesModal', button);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function viewApplicantFiles(_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return viewApplicantFiles;
    }(),
    viewApplicantWorkingProfile: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(item, index, button) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('\n\n ======== PendingCollection <|-- viewApplicantWorkingProfile ======= \n item: ', item, '\n -----------------------');
                console.log('\n\n ======== PendingCollection <|-- viewApplicantWorkingProfile ======= \n index: ', index, '\n -----------------------');
                console.log('\n\n ======== PendingCollection <|-- viewApplicantWorkingProfile ======= \n button: ', button, '\n -----------------------');

                this.viewWorkingProfileModal.obj = item;
                this.viewWorkingProfileModal.title = item.fullname + ' - ' + item.nricFin;

                this.$root.$emit('bv::show::modal', 'viewApplicantWorkingProfileModal', button);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function viewApplicantWorkingProfile(_x5, _x6, _x7) {
        return _ref3.apply(this, arguments);
      }

      return viewApplicantWorkingProfile;
    }(),
    viewApplicantBookedModules: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(item, index, button) {
        var userActorId, managerId, manager, moduleSessionList, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, msId, moduleSession, msStatusId, moduleSessionStatus;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('\n\n ======== PendingCollection <|-- viewApplicantBookedModules ======= \n item: ', item, '\n -----------------------');
                console.log('\n\n ======== PendingCollection <|-- viewApplicantBookedModules ======= \n index: ', index, '\n -----------------------');
                console.log('\n\n ======== PendingCollection <|-- viewApplicantBookedModules ======= \n button: ', button, '\n -----------------------');

                userActorId = item.id;
                managerId = 'userMsManager' + userActorId;
                _context4.next = 7;
                return axios.post('/userMsManager/obtainSingleManager', { managerId: managerId });

              case 7:
                manager = _context4.sent.data.manager;


                this.viewBookedModuleModal.obj = item;
                this.viewBookedModuleModal.title = item.fullname + ' - ' + item.nricFin;

                moduleSessionList = [];
                // let statusList = [];

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 14;
                _iterator = _getIterator(manager.bookedModules);

              case 16:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context4.next = 29;
                  break;
                }

                msId = _step.value;
                _context4.next = 20;
                return axios.get('/moduleSession/' + msId);

              case 20:
                moduleSession = _context4.sent.data;
                msStatusId = 'msStatus' + msId + item.id;
                _context4.next = 24;
                return axios.post('/userMsStatus/userMsStatusCode', { msStatusId: msStatusId });

              case 24:
                moduleSessionStatus = _context4.sent.data;

                moduleSessionList.push(_extends({ moduleSession: moduleSession }, moduleSessionStatus));

                // statusList.push(moduleSessionStatus,...moduleSession);

              case 26:
                _iteratorNormalCompletion = true;
                _context4.next = 16;
                break;

              case 29:
                _context4.next = 35;
                break;

              case 31:
                _context4.prev = 31;
                _context4.t0 = _context4['catch'](14);
                _didIteratorError = true;
                _iteratorError = _context4.t0;

              case 35:
                _context4.prev = 35;
                _context4.prev = 36;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 38:
                _context4.prev = 38;

                if (!_didIteratorError) {
                  _context4.next = 41;
                  break;
                }

                throw _iteratorError;

              case 41:
                return _context4.finish(38);

              case 42:
                return _context4.finish(35);

              case 43:
                this.viewBookedModuleModal.content = moduleSessionList;
                // this.viewBookedModuleModal.status = statusList;
                console.log('\n\n ======== PendingCollection <|-- viewApplicantBookedModules content ======= \n', this.viewBookedModuleModal.content, '\n -----------------------');
                console.log('\n\n ======== PendingCollection <|-- viewApplicantBookedModules statusList======= \n', this.viewBookedModuleModal.status, '\n -----------------------');

                this.$root.$emit('bv::show::modal', 'viewApplicantBookedModulesModal', button);

              case 47:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[14, 31, 35, 43], [36,, 38, 42]]);
      }));

      function viewApplicantBookedModules(_x8, _x9, _x10) {
        return _ref4.apply(this, arguments);
      }

      return viewApplicantBookedModules;
    }(),
    resetModal: function resetModal(modal) {
      console.log(modal);
      modal.title = '';
      modal.content = '';
      // if(!!modal.status){
      //   modal.status = null;
      // }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/pendingAction/PendingCollection.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/pendingAction/PendingCollection.vue
// module chunks = 1 4